import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=a196c2f2&"
import script from "./loginDialog.vue?vue&type=script&lang=js&"
export * from "./loginDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports